import { injectBillingEndpoints } from "../../../../core/store/reduxApi/billing";
import { reduxApiSlice } from "./index";
import type {
  PlanSummaryResponse,
  UpdateSubscriptionRequest,
  UpdateSubscriptionResponse,
} from "../../../../core/store/reduxApi/billing";
import type {
  BaseQueryFn,
  TypedUseMutation,
  TypedUseQuery,
} from "@reduxjs/toolkit/query/react";

export type {
  BillingInterval,
  PlanSummaryResponse,
  UpdateSubscriptionRequest,
  UpdateSubscriptionResponse,
} from "../../../../core/store/reduxApi/billing";

const extendedApi = injectBillingEndpoints(reduxApiSlice);

export const useGetPlanSummaryQuery =
  extendedApi.useGetPlanSummaryQuery as TypedUseQuery<
    PlanSummaryResponse,
    void,
    BaseQueryFn
  >;
export const useUpdateSubscriptionMutation =
  extendedApi.useUpdateSubscriptionMutation as TypedUseMutation<
    UpdateSubscriptionResponse,
    UpdateSubscriptionRequest,
    BaseQueryFn
  >;
